import router from '@/router';
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        pagination: { data: [], current_page: 1 },
        event: {},
        loadings: { index: false, show: false, store: false, update: false, delete: false }
    },
    mutations: {
        SET_PAGINATED_EVENTS: (state, pagination) => state.pagination = pagination,
        SET_EVENT: (state, event) => state.event = event,
        TOGGLE_LOADING: (state, loading) => state.loadings[loading] = !state.loadings[loading],
        DROP_EVENT: (state, index) => state.pagination.data.splice(index, 1),
    },
    actions: {
        fetchEvents({ commit }, page = {} ) {
            commit('TOGGLE_LOADING', 'index')
            return this.$repository.events
                .index(page)
                .then(({ data }) => {
                    commit('SET_PAGINATED_EVENTS', data)
                    return data
                })
                .finally(() => commit('TOGGLE_LOADING', 'index'))
        },
        fetchEvent({ commit }, id) {
            commit('TOGGLE_LOADING', 'show')
            return this.$repository.events
                .show(id)
                .then(({ data }) => {
                    commit('SET_EVENT', data)
                    return data
                })
                .finally(() => commit('TOGGLE_LOADING', 'show'))
        },
        fetchEventinvitations({ commit }, id) {
            commit('TOGGLE_LOADING', 'show')
            return this.$repository.events
                .get_invitations(id)
                /*.then(({ data }) => {
                    commit('SET_EVENT', data)
                    return data
                })*/
                .finally(() => commit('TOGGLE_LOADING', 'show'))
        },
        store({ commit }, body) {
            commit('TOGGLE_LOADING', 'store')
            return this.$repository.events
                .store(body)
                .then(({ data }) => {
                    Vue.prototype.$message.success({
                        message: `The Event has been created successfully`,
                        text: `The Event has been created successfully`,
                        description: `The Event has been created successfully`,
                        position: `top-right`
                    })
                    router.push({ name: 'events.index' })
                    return data
                })
                .finally(() => commit('TOGGLE_LOADING', 'store'))
        },
        update({ commit }, body) {
            commit('TOGGLE_LOADING', 'update')
            return this.$repository.events
                .update(body.id,  body)
                .then(({ data }) => {
                    Vue.prototype.$message.success({
                        message: `The user has been updated successfully`,
                        text: `The user has been updated successfully`,
                        description: `The user has been updated successfully`,
                        position: `top-right`
                    })
                    router.push({ name: 'events.index' })
                    return data
                })
                .finally(() => commit('TOGGLE_LOADING', 'update'))
        },
        delete({ commit,state }, body) {
            if (confirm('Do you want to delete this Event?')) {
                commit('TOGGLE_LOADING', 'delete')
                return this.$repository.events
                    .delete(body.id)
                    .then(({ data }) => {
                        const index = state.pagination.data.findIndex(event => event.id === body.id)
                            if (index !== -1) {
                                commit('DROP_EVENT', index)
                            }
                        return data
                    })
                    .finally(() => commit('TOGGLE_LOADING', 'delete'))
            }
        }
    },
    getters: {
        eventCanDo: (state, getters, rootState, rootGetters) => action => {
            return rootGetters["session/isAuthenticated"]
            && rootState.session.event.permissions.hasOwnProperty(action)
            && rootState.session.event.permissions[action]
        }
    }
}